<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage" style="margin-right: 20px">
    <div>
      <span style="color:#fff;">全部应用</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown" class="appSelect">
      <!--<el-dropdown-item command="-1">-->
      <!--<div class="img"></div>-->
      <!--<span>全部应用</span>-->
    <!--</el-dropdown-item>-->
      <el-dropdown-item :command="item" v-for="item in list" :key="item.appId">
        <img class="img" :src="item.appIconUrl">
        <span>{{item.appName}}</span>
      </el-dropdown-item>
      <!--<el-dropdown-item command="4">-->
        <!--<img class="img" src="../../../assets/image/common/enterprise.png">-->
        <!--<span>item.appName</span>-->
      <!--</el-dropdown-item>-->
      <!--<el-dropdown-item command="1">-->
        <!--<img class="img" src="../../../assets/image/common/system.png">-->
        <!--<span>系统管理</span>-->
      <!--</el-dropdown-item>-->
      <!--<el-dropdown-item command="5">-->
        <!--<img class="img" src="../../../assets/image/common/change.png">-->
        <!--<span>变更管理</span>-->
      <!--</el-dropdown-item>-->
      <!--<el-dropdown-item command="6">-->
        <!--<img class="img" src="../../../assets/image/common/cost.png">-->
        <!--<span>费用控制</span>-->
      <!--</el-dropdown-item>-->
      <!--<el-dropdown-item command="7">-->
        <!--<img class="img" src="../../../assets/image/common/project.png">-->
        <!--<span>项目与合同</span>-->
      <!--</el-dropdown-item>-->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import LoginApi from "@/api/LoginApi"
  import {convertToRoute, convertToMenu} from "@/util/util";
  import Cookie from 'js-cookie'
  import {mapGetters} from 'vuex'
  import http from '@/util/http'
  import {resolveUrlPath, setUrlPath} from '@/util/util'
  import auth from '@/util/auth';
  // import { menu} from '@/mock/menu'
  export default {
    name: 'top-app-select',
    data() {
      return {
        access: [],
        list: [],
      }
    },
    computed: mapGetters(['isLock', 'token']),
    created() {
      let loginApi = new LoginApi();
      //获取应用列表
      loginApi.access({}).then(res => {
        this.list = res.data
      })
    },
    methods: {
      handleSetLanguage(app) {
        let url = window.location.host;
        if(process.env.NODE_ENV == 'development'){
          // 如果是开发环境
          window.location.href = 'http://' + url + '/#/wel/index?token=' + this.token + '&appId=' + app.appId;
        }else {
          window.location.href = 'http://' + app.appUrl + app.description + '/#/wel/index?token=' + this.token + '&appId=' + app.appId;
        }
      }
    },
  }
</script>

<style scoped>
  .international-icon {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -5px!important;
  }
</style>
